import React, { useContext, useState, useEffect } from 'react'
import Classes from '../Cart.module.css'
import TableRow from '../TableRow';
import { CartContext } from '../../../Context/CartContext';
import BillingInfo from './BillingInfo';
import ProductsInfo from './ProductsInfo';
import { AnimatePresence, motion } from 'framer-motion';

export default function CartSidebar({ setopenCart }) {
    const {
        cartItems,
        removeFromCart,
        updateQuantity,
        getCartTotal,
        getCartCount,
        clearCart
    } = useContext(CartContext);

    const [IsShowBillingInfo, setIsShowBillingInfo] = useState(false);
    const generateWhatsAppMessage = (cartItems, billing) => {
        // Generate 6-digit order ID
        const orderId = Math.floor(100000 + Math.random() * 900000);

        // Format order items with IDs, images, and totals
        const itemsText = cartItems.map(item => (
            `➤ *${item.title}* 
            ID: ${item.id}
            Size: ${item.selectedSize || 'N/A'}
            Qty: ${item.quantity} × AED ${item.price.toFixed(2)}
            *Item Total: AED ${(item.price * item.quantity).toFixed(2)}*
            Image: ${item.selectedImage || item.image}
            ━━━━━━━━━━━━━━━━━━`
        )).join('\n');

        // Calculate order totals
        const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        const shipping = 0; // Free shipping
        const grandTotal = subtotal + shipping;

        // Format billing address
        const billingAddress = `
    ${billing.address1}${billing.address2 ? '\n' + billing.address2 : ''}
    ${billing.city}, ${billing.state} ${billing.zip}`;

        // Compose final message
        return `📋 *ORDER #${orderId} CONFIRMED*
    
    👤 *CUSTOMER*
    • Name: ${billing.firstName} ${billing.lastName}
    • Phone: ${billing.phone}
    • Email: ${billing.email}
    
    🏠 *SHIPPING ADDRESS*
    ${billingAddress}
    
    🛍️ *ORDER ITEMS*
    ${itemsText}
    
    💰 *ORDER SUMMARY*
    Subtotal: AED ${subtotal.toFixed(2)}
    Shipping: *free*
    *GRAND TOTAL: AED ${grandTotal.toFixed(2)}*
    
    💳 *PAYMENT METHOD*: ${billing.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Online Payment'}
    
    Thank you for your business!`;
    };

    const sendOrderViaWhatsApp = () => {
        const message = generateWhatsAppMessage(cartItems, billing);
        const whatsappUrl = `https://wa.me/971502466347?text=${encodeURIComponent(message)}`;

        // Open in new tab (better UX)
        window.open(whatsappUrl, '_blank');
    };


    const handleOrderNow = (e) => {
        e.preventDefault();

        localStorage.setItem('billing', JSON.stringify(billing));

        sendOrderViaWhatsApp();

        // clearCart();

        // enqueueSnackbar('Order submitted successfully!', { variant: 'success' });
    };
    const initialBilling = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        paymentMethod: 'cod'
    };

    const [billing, setBilling] = useState(() => {
        const saved = localStorage.getItem('billing');
        return saved ? JSON.parse(saved) : initialBilling;
    });

    useEffect(() => {
        localStorage.setItem('billing', JSON.stringify(billing));
    }, [billing]);

    return (
        <>
            <form onSubmit={handleOrderNow} className={Classes.sidebar} id='cart-top' >
                <AnimatePresence mode="wait">
                    {IsShowBillingInfo ?
                        <motion.div
                            key="firstCard"
                            initial={{ x: -10, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: -10, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            style={{ height: '100%' }}
                        >
                            <BillingInfo setIsShowBillingInfo={setIsShowBillingInfo} billing={billing} setBilling={setBilling} />
                        </motion.div>
                        :
                        <motion.div
                            key="secondCard"
                            initial={{ x: 10, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: 10, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            style={{ height: '100%' }}
                        >
                            <ProductsInfo
                                handleOrderNow={handleOrderNow}
                                setopenCart={setopenCart}
                                setIsShowBillingInfo={setIsShowBillingInfo}
                            />
                        </motion.div>
                    }
                </AnimatePresence>
            </form>
        </>
    )
}
